
const aminities = [
  { id:1,  category_id:1, aminitie_name:"Grand Entrance Lobby"        },
  { id:2,  category_id:1, aminitie_name:"Co-working / Business Center" },
  { id:3,  category_id:1, aminitie_name:"Library & Reading Lounge"    },
  { id:4,  category_id:1, aminitie_name:"Multipurpose Party Hall"     },
  { id:5,  category_id:2, aminitie_name:"Fully Equipped Gym"          },
  { id:6,  category_id:2, aminitie_name:"Swimming Pool"               },
  { id:7,  category_id:2, aminitie_name:"Basketball Court"            },
  { id:8,  category_id:2, aminitie_name:"Jogging Track"               },
  { id:9,  category_id:2, aminitie_name:"Cycling Track"               },
  { id:10, category_id:2, aminitie_name:"Badminton Court"             },
  { id:11, category_id:3, aminitie_name:"Kids Play Area"              },
  { id:12, category_id:3, aminitie_name:"Senior Citizen Zone"         },
  { id:13, category_id:4, aminitie_name:"24/7 CCTV Security"          },
  { id:14, category_id:4, aminitie_name:"Fire Safety System"          },
  { id:15, category_id:4, aminitie_name:"Power Backup"                },
  { id:16, category_id:5, aminitie_name:"Landscaped Gardens"          },
  { id:17, category_id:5, aminitie_name:"Rooftop Garden"              },
  { id:18, category_id:6, aminitie_name:"Smart Home Features"         },
  { id:19, category_id:6, aminitie_name:"EV Charging"                 },
  { id:20, category_id:7, aminitie_name:"BBQ Zone"                    },
  { id:21, category_id:7, aminitie_name:"Yoga & Meditation Hall"      },
];
export default aminities;